import { Environment } from 'shared/enums/environments.js';

import { environment } from '../utils/environments.js';
import { devConfig } from './envs/dev.js';
import { prodConfig } from './envs/prod.js';
import { ssgConfig } from './envs/ssg.js';
import type { FrontendConfig } from './types.js';

const configsByEnv: { [key in Environment]: FrontendConfig } = {
  [Environment.Local]: devConfig, // placeholder — overwritten before app renders
  [Environment.Dev]: devConfig,
  [Environment.Prod]: prodConfig,
  [Environment.SSG]: ssgConfig,
};

export let config: FrontendConfig = configsByEnv[environment];

export const configReady: Promise<void> = import.meta.env.DEV
  ? import('./envs/local.js').then((m) => {
      config = m.localConfig;
    })
  : Promise.resolve();
